import { cn } from "@/lib/cn";

interface Props {
  className?: string;
  /** when true, the cascade segments light up in sequence (live dispatch) */
  animated?: boolean;
  title?: string;
}

/**
 * The deleggate mark: three rounded-pill segments cascading down-right
 * (dispatch / delegation) into a ringed orbit node with a satellite.
 * Uses `currentColor`, so color it with `text-*`. When `animated`, the
 * segments pulse in top-to-bottom sequence — the product's heartbeat.
 */
export function DispatchMark({ className, animated = false, title }: Props) {
  return (
    <svg
      viewBox="0 0 657 935"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? "img" : "presentation"}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      className={cn(animated && "dgg-flow", className)}
    >
      {/* top → middle → bottom cascade, staggered so dispatch reads downward */}
      <rect x="284" y="189.442" width="301.873" height="136.508" rx="33" transform="rotate(-38.87 284 189.442)" style={{ animationDelay: "0s" }} />
      <rect x="286" y="391.442" width="301.873" height="136.508" rx="33" transform="rotate(-38.87 286 391.442)" style={{ animationDelay: "0.18s" }} />
      <rect x="272.573" y="599.963" width="254.899" height="136.508" rx="33" transform="rotate(-38.87 272.573 599.963)" style={{ animationDelay: "0.36s" }} />
      {/* orbit node */}
      <path
        style={{ animationDelay: "0.54s" }}
        d="M229.5 473C356.249 473 459 575.751 459 702.5C459 829.249 356.249 932 229.5 932C102.751 932 0 829.249 0 702.5C0 575.751 102.751 473 229.5 473ZM229 611C178.19 611 137 652.19 137 703C137 753.81 178.19 795 229 795C279.81 795 321 753.81 321 703C321 652.19 279.81 611 229 611Z"
      />
      {/* satellite */}
      <circle cx="588" cy="866" r="69" style={{ animationDelay: "0.72s" }} />
    </svg>
  );
}
